import SettingsIcon from '@material-ui/icons/Settings';
import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission } from '../../generated/graphql';
import Settings from './Settings';
import CustomPaymentMethods from './CustomPaymentMethods';
import UpdateCustomPaymentMethod from './UpdateCustomPaymentMethod';
import CreateCustomPaymentMethod from './CreateCustomPaymentMethod';

const SettingsRoute: RouteType = {
    exact: true,
    path: routePaths.settings,
    icon:  SettingsIcon,
    title: translate('Settings'),
    permissions: {
        backoffice: [
            BackofficePermission.HasAccess,
            BackofficePermission.CanViewPaymentMethods,
        ],
    },
    redirectRoute: routePaths.dashboard,
    component: Settings,
    childrenRoutes: [
        {
            exact: true,
            showInSideBar: true,
            title: translate('Payment methods'),
            path: routePaths.customPaymentMethodsSettings,
            component: CustomPaymentMethods,
            permissions: {
                backoffice: [
                    BackofficePermission.HasAccess,
                    BackofficePermission.CanViewPaymentMethods,
                ],
            },
            redirectRoute: routePaths.settings,
        },
        {
            exact: true,
            title: translate('Create payment method'),
            path: routePaths.customPaymentMethodsSettingsCreate,
            component: CreateCustomPaymentMethod,
            permissions: {
                backoffice: [
                    BackofficePermission.HasAccess,
                    BackofficePermission.CanViewPaymentMethods,
                    BackofficePermission.CanAddPaymentMethods,
                ],
            }
        },
        {
            exact: true,
            title: translate('Update payment method'),
            path: routePaths.customPaymentMethodsSettingsUpdate,
            component: UpdateCustomPaymentMethod,
            permissions: {
                backoffice: [
                    BackofficePermission.HasAccess,
                    BackofficePermission.CanViewPaymentMethods,
                    BackofficePermission.CanUpdatePaymentMethods
                ],
            }
        },
        {
            exact: false,
            title: translate('Redirect'),
            path: routePaths.customPaymentMethodsSettings,
            component: Settings
        }
    ],
};

export default SettingsRoute;
